
import React from 'react';

interface TopicCardProps {
  id: string;
  title: string;
  isActive: boolean;
  onClick: () => void;
}

const TopicCard: React.FC<TopicCardProps> = ({ id, title, isActive, onClick }) => {
  const baseClasses = "block text-center p-3 sm:p-4 rounded-lg shadow-sm hover:shadow-lg hover:scale-105 transition-all duration-300 ease-in-out border w-full";
  const activeClasses = "bg-sky-600 text-white border-sky-700";
  const inactiveClasses = "bg-white text-slate-700 border-slate-200 hover:border-sky-500 hover:text-sky-600";

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}
      aria-pressed={isActive}
    >
      <h3 className="text-sm md:text-base font-semibold">{title}</h3>
    </button>
  );
};

export default TopicCard;
